// Sends an issuer's links to another verifier while its own site is down, without rewriting the
// redirect stored in every issued document. Keys in `overrides` are exact host names.
export const resolveRedirect = (redirect, overrides) => {
  if (!redirect) return redirect;

  // strip trailing slash(es) so the query string/hash append cleanly
  // (e.g. https://okada.edu.gh/okada-verify-document.html/ -> .../okada-verify-document.html?q=...)
  const stripped = redirect.replace(/\/+$/, "");

  let host;
  try {
    host = new URL(stripped).hostname;
  } catch (e) {
    return stripped;
  }

  const target = overrides && Object.prototype.hasOwnProperty.call(overrides, host) ? overrides[host] : null;
  return target ? target.replace(/\/+$/, "") : stripped;
};
